<template>
  <transition name="fade">
    <div id="JoinUs" v-if="visible" @click="handCloseClick">
      <!-- 这里放置 JoinUs 组件的具体内容 -->
      <div class="title">
        微信扫一扫<br/>
        添加您的专属售前顾问
      </div>
      <img class="qrcode" src="../assets/images/qrcode.png" alt="">
      <div class="close-btn">点击关闭</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'JoinUs',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    handCloseClick() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
#JoinUs {
  position: fixed;
  z-index: 9999;
  top: 45%;
  left: 50%;
  margin-left: -120px;
  margin-top: -159px;
  width: 240px;
  /* height: 272px; */
  background: #FFFFFF;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.17);
  border-radius: 2px;
  cursor: pointer;
}

.title{
  padding: 20px 0;
  font-family: zihun59hao, zihun59hao;
  font-weight: normal;
  font-size: 16px;
  color: rgba(0,0,0,0.9);
  line-height: 19px;
  text-align: center;
  font-style: normal;
}

.qrcode{
  width: 200px;
  height: 200px;
  /* padding: 10px; */
  display: block;
  margin: 0 auto;
}

.close-btn{
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 10px 0;
}
/* 淡入淡出动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/JoinUs.vue